import { useContext } from "react";
import AuthContext from "../context/AuthProvider";
import DashContext from "../context/DashboardProvider";
import StoreContext from "../context/GeneralProvider";
import ComplianceContext from "../context/ComplianceProvider";

const useAuth = () => {
  return useContext(AuthContext);
};

export default useAuth;

export const useDashboardContext = () => {
  return useContext(DashContext);
};

export const useStore = () => {
  return useContext(StoreContext);
};

export const useComplianceContext = () => {
  return useContext(ComplianceContext);
};
